export default __webpack_public_path__ + "static/media/Diviner's Hood of the Dark Pact.fdc733bd.jpg";